import { render, staticRenderFns } from "./ColLabel.vue?vue&type=template&id=e1dc856a&scoped=true&"
import script from "./ColLabel.vue?vue&type=script&lang=js&"
export * from "./ColLabel.vue?vue&type=script&lang=js&"
import style0 from "./ColLabel.vue?vue&type=style&index=0&id=e1dc856a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1dc856a",
  null
  
)

export default component.exports